(function(algolia) {
  'use strict';

  if (!algolia || !algolia.config) return;

  // Legacy generated config isn't refreshed by the v5 dashboard toggle, so
  // keep storefront-specific settings in a theme-owned override.
  algolia.config.collection_css_selector = '#main_content_area';
  algolia.config.search_client_version = 5;
  algolia.config.instant_search_enabled_on_collection = false;
})(window.algoliaShopify);
